import React from 'react';

import { l10n } from '@ott/l10n';

import styles from './PassengerOption.scss';

type Props = {
  isActive: boolean;
  isHovered: boolean;
  option: {
    label: string;
    value: string;
    birthDate: string;
    documentNumber: string;
    fullName: string;
  };
};

export const PassengerOption = ({ option: { birthDate, documentNumber, fullName } }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.mainInfo}>{fullName}</div>
      <div className={styles.additionalInfo}>
        <span>{birthDate}</span>,{' '}
        <span>{l10n('passengers.passengerForm.fields.documentType.items.RU.PASSPORT')}</span>,{' '}
        <span>{documentNumber}</span>
      </div>
    </div>
  );
};
